import { constants as config } from '@config';

function getProjectLoadData (asyncLoadKey) {
  const projectLoadData = getLoadingArgument(asyncLoadKey);
  return projectLoadData ? JSON.parse(projectLoadData) : null;
}

function getLoadingArgument (name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length > 1) return parts.pop().split(';').shift();
}

function setBookType ({ template, design }) {
  const encodedId = design || template;

  INKIVE.C.BOOK = {
    id: encodedId,
    encodedId,
    book_type: template
      ? INKIVE.C.BOOK_TYPE.TEMPLATE
      : INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN,
    cookiesInitialized: true
  };
}

export default (() => {
  const projectLoadData = getProjectLoadData(config.cookies.loadKey);
  if (!projectLoadData) return;

  setBookType(projectLoadData);
})();
